import saveItem from './saveItem';
import {
    addFileAttachment,
    addItemAttachment,
    removeAttachment,
    getAttachments,
    addFileAttachmentFromBase64,
} from './AttachmentAdapter';
import {
    addNotificationMessage,
    removeNotificationMessage,
    getNotificationMessageIds,
} from '../NotificationMessageAdapters/ComposeNotificationMessageAdapter';
import { addRecipients, getRecipients, setRecipients } from './RecipientsAdapter';
import { closeItem } from './CloseAdapter';
import { ComposeViewState } from 'owa-mail-compose-store';
import { displayAppointmentForm } from '../CommonAdapters/DisplayAppointmentFormAdapter';
import { displayMessageForm } from '../CommonAdapters/DisplayMessageFormAdapter';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import {
    getBody,
    getBodyType,
    prependBody,
    setBody,
    setBodySelectedData,
    appendOnSendAdapter as appendOnSend,
} from './BodyAdapter';
import { getComposeInternetHeaders as getInternetHeaders } from '../CommonAdapters/GetInternetHeadersAdapter';
import { getComposeItemId as getItemId } from '../CommonAdapters/ItemIdAdapter';
import { getConversationId } from './ConversationIdAdapter';
import { getFrom } from './FromAdapter';
import { getSelectedData, setSelectedData } from './SelectedDataAdapter';
import { getSubject, setSubject } from './SubjectAdapter';
import { isComposeAddinPinned as isAddinPinned } from '../CommonAdapters/IsAddinPinnedAdapter';
import { isSharedItemForCompose } from '../CommonAdapters/SharedItemAdapter';
import { MessageComposeAdapter } from 'owa-addins-core';
import {
    setInternetHeadersAdapter as setInternetHeaders,
    removeInternetHeadersAdapter as removeInternetHeaders,
} from './InternetHeadersAdapter';

export default function createMailComposeAdapter(
    viewState: ComposeViewState
): MessageComposeAdapter {
    return {
        getRecipients: getRecipients(viewState),
        setRecipients: setRecipients(viewState),
        addRecipients: addRecipients(viewState),
        getSubject: getSubject(viewState),
        setSubject: setSubject(viewState),
        getItemId: getItemId(viewState),
        getConversationId: getConversationId(viewState),
        getBody: getBody(viewState),
        setBody: setBody(viewState),
        getBodyType: getBodyType(viewState),
        prependBody: prependBody(viewState),
        getSelectedData: getSelectedData(viewState),
        setSelectedData: setSelectedData(viewState),
        setBodySelectedData: setBodySelectedData(viewState),
        mode: ExtensibilityModeEnum.MessageCompose,
        saveItem: saveItem(viewState),
        addNotificationMessage: addNotificationMessage(viewState),
        removeNotificationMessage: removeNotificationMessage(viewState),
        getNotificationMessageIds: getNotificationMessageIds(viewState),
        close: closeItem(viewState),
        displayMessageForm,
        displayAppointmentForm,
        addItemAttachment: addItemAttachment(viewState),
        addFileAttachment: addFileAttachment(viewState),
        addFileAttachmentFromBase64: addFileAttachmentFromBase64(viewState),
        removeAttachment: removeAttachment(viewState),
        getAttachments: getAttachments(viewState),
        isAddinPinned,
        isSharedItem: isSharedItemForCompose(viewState),
        getFrom: getFrom(viewState),
        getInternetHeaders: getInternetHeaders(viewState),
        setInternetHeaders: setInternetHeaders(viewState),
        removeInternetHeaders: removeInternetHeaders(viewState),
        appendOnSend: appendOnSend(viewState),
    };
}
